const HeroLeft = ({ title, subtitle }) => (
  <div className="bg-neutral-50 py-[100px]">
    <div className="container">
      <h1 className="text-4xl text-black font-aeonik">{title}</h1>
      <p className="max-w-3xl mt-4 text-base text-stone-600">{subtitle}</p>
    </div>
  </div>
);

export default HeroLeft;
